// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__38YnK","notes":"Notes_notes__3K97-"};